module.exports = __webpack_public_path__ + "static/img/ry06-card-bg.f666bda9.png";